import StoreBtn from "./StoreBtn";
import StarField from "./StarField";
import { trackHeroScrollCta } from "../analytics";
import { useSectionTrack } from "../hooks/useSectionTrack";

// Orange radial glows behind the phone mockup — same vibe as mobile glow1/2/3
const GLOWS = [
  { style: { width: "60%",  left: "-6%",   top: "18%",  background: "radial-gradient(circle at 50% 50%, rgba(255,122,48,.32) 0%, rgba(255,122,48,.10) 45%, rgba(255,102,0,0) 75%)", filter: "blur(40px)" } },
  { style: { width: "38%",  right: "-4%",  top: "-2%",  background: "radial-gradient(circle at 50% 50%, rgba(255,184,80,.22) 0%, rgba(255,184,80,.06) 50%, rgba(255,184,80,0) 80%)", filter: "blur(36px)" } },
  { style: { width: "30%",  left: "10%",   bottom: "0%", background: "radial-gradient(circle at 50% 50%, rgba(255,154,64,.18) 0%, rgba(255,154,64,.04) 50%, rgba(255,154,64,0) 80%)", filter: "blur(44px)" } },
];

const ABS_GLOW_BASE = { position: "absolute", pointerEvents: "none", zIndex: 0, aspectRatio: "1/1", borderRadius: "50%" };

function PhoneStack() {
  return (
    <div style={{ position: "relative", width: "100%", maxWidth: 560, flexShrink: 0 }}>
      {GLOWS.map((g, i) => <div key={i} style={{ ...ABS_GLOW_BASE, ...g.style }} />)}
      <img
        src="/phones-mockup.png"
        alt="Wychodzi — найди компанию рядом"
        style={{ position: "relative", zIndex: 1, width: "100%", display: "block", userSelect: "none", pointerEvents: "none" }}
      />
    </div>
  );
}

export default function Hero() {
  const ref = useSectionTrack("hero");

  return (
    <section ref={ref} className="hero-section" style={{ background: "transparent", overflow: "hidden", position: "relative" }}>
      <StarField density={1} />

      <div className="hero-left">
        <div className="hero-badge">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
          Закрытая бета
        </div>

        <h1 className="hero-headline">
          <span>Найди куда пойти.</span>
          <span>Или <span className="hero-grad-word">с кем</span>.</span>
        </h1>

        <p className="hero-sub">
          План на сегодня вечером в твоём городе — за один тап. Сквош, мафия, теннис, пляжный волейбол.
        </p>

        <div className="hero-slogan">
          Выходи. Куда — и с кем разберёмся.
        </div>

        {/* Mobile-only inline phone preview — shows above the store buttons */}
        <div className="hero-mobile-preview">
          <div className="hero-mobile-preview-inner">
            {GLOWS.map((g, i) => <div key={i} style={{ ...ABS_GLOW_BASE, ...g.style }} />)}
            <img
              src="/phones-mockup.png"
              alt="Wychodzi — найди компанию рядом"
              style={{ position: "relative", zIndex: 1, width: "100%", display: "block", userSelect: "none", pointerEvents: "none" }}
            />
          </div>
        </div>

        <div className="store-btns" style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 20 }}>
          <StoreBtn kind="apple"  location="hero" />
          <StoreBtn kind="google" location="hero" />
        </div>

        <a href="#how" className="hero-scroll-link" onClick={trackHeroScrollCta}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
            <path d="M12 5v14M5 15l7 7 7-7"/>
          </svg>
          Как это работает
        </a>
      </div>

      <div className="hero-right">
        <PhoneStack />
      </div>
    </section>
  );
}
